import * as React from 'react'
import { UploadedFileCardConnected } from './UploadedFileCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UploadedFileCardExamples = () => {
  return (
    <div className="UploadedFileCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadedFileCardConnected uploadedFileId={'foo'} />
      </Provider>
    </div>
  )
}
